<template>
  <div>
    <div
      class="tw-bg-white tw-rounded-[6px] tw-border-solid tw-border-[1px] tw-border-forLine tw-p-[15px] tw-mb-[15px]"
      v-if="fundsSettingsLoadStatus == 'success'"
    >
      <div
        class="tw-text-[15px] tw-text-forTitle tw-font-semibold tw-mb-[15px]"
      >
        Пользовательские счета
      </div>
      <div class="tw-mb-[15px]">
        <div class="tw-app-input-type-3-label">
          {{ dataLang?.cash_account_3 }}
        </div>
        <BaseInput
          inputClass="tw-app-input-type-3"
          title="Default Title"
          ref="company_settings__set_req_company_name"
          input-name="company_settings__set_req_company_name"
          :value="getValue(3)?.finreestr_funds__name"
          :disabled="!getValue(3)?.finreestr_funds__is_edit_settings"
          @onInput="updateValue($event, 3)"
          :placeholder="dataLang?.cash_account_3"
        ></BaseInput>
      </div>

      <div class="tw-mb-[15px]">
        <div class="tw-app-input-type-3-label">
          {{ dataLang?.cash_account_4 }}
        </div>
        <BaseInput
          inputClass="tw-app-input-type-3"
          title="Default Title"
          ref="company_settings__set_req_company_name"
          input-name="company_settings__set_req_company_name"
          :value="getValue(4)?.finreestr_funds__name"
          :disabled="!getValue(4)?.finreestr_funds__is_edit_settings"
          @onInput="updateValue($event, 4)"
          :placeholder="dataLang?.cash_account_4"
        ></BaseInput>
      </div>
    </div>

    <div
      class="tw-bg-white tw-rounded-[6px] tw-border-solid tw-border-[1px] tw-border-forLine tw-p-[15px] tw-mb-[15px]"
      v-if="fundsSettingsLoadStatus == 'success'"
    >
      <div
        class="tw-text-[15px] tw-text-forTitle tw-font-semibold tw-mb-[15px]"
      >
        Пользовательские фонды
      </div>

      <div class="tw-mb-[15px]">
        <div class="tw-app-input-type-3-label">
          {{ dataLang?.fund_10 }}
        </div>
        <BaseInput
          inputClass="tw-app-input-type-3"
          title="Default Title"
          ref="company_settings__set_req_company_name"
          input-name="company_settings__set_req_company_name"
          :value="getValue(16)?.finreestr_funds__name"
          :disabled="!getValue(16)?.finreestr_funds__is_edit_settings"
          @onInput="updateValue($event, 16)"
        ></BaseInput>
      </div>

      <div class="tw-mb-[15px]">
        <div class="tw-app-input-type-3-label">
          {{ dataLang?.fund_11 }}
        </div>
        <BaseInput
          inputClass="tw-app-input-type-3"
          title="Default Title"
          ref="company_settings__set_req_company_name"
          input-name="company_settings__set_req_company_name"
          :value="getValue(17)?.finreestr_funds__name"
          :disabled="!getValue(17)?.finreestr_funds__is_edit_settings"
          @onInput="updateValue($event, 17)"
        ></BaseInput>
      </div>

      <div class="tw-mb-[15px]">
        <div class="tw-app-input-type-3-label">
          {{ dataLang?.fund_12 }}
        </div>
        <BaseInput
          inputClass="tw-app-input-type-3"
          title="Default Title"
          ref="company_settings__set_req_company_name"
          input-name="company_settings__set_req_company_name"
          :value="getValue(18)?.finreestr_funds__name"
          :disabled="!getValue(18)?.finreestr_funds__is_edit_settings"
          @onInput="updateValue($event, 18)"
        ></BaseInput>
      </div>

      <div class="tw-mb-[15px]">
        <div class="tw-app-input-type-3-label">
          {{ dataLang?.fund_13 }}
        </div>
        <BaseInput
          inputClass="tw-app-input-type-3"
          title="Default Title"
          ref="company_settings__set_req_company_name"
          input-name="company_settings__set_req_company_name"
          :value="getValue(19)?.finreestr_funds__name"
          :disabled="!getValue(19)?.finreestr_funds__is_edit_settings"
          @onInput="updateValue($event, 19)"
        ></BaseInput>
      </div>

      <div class="tw-mb-[15px]">
        <div class="tw-app-input-type-3-label">
          {{ dataLang?.fund_14 }}
        </div>
        <BaseInput
          inputClass="tw-app-input-type-3"
          title="Default Title"
          ref="company_settings__set_req_company_name"
          input-name="company_settings__set_req_company_name"
          :value="getValue(20)?.finreestr_funds__name"
          :disabled="!getValue(20)?.finreestr_funds__is_edit_settings"
          @onInput="updateValue($event, 20)"
        ></BaseInput>
      </div>

      <div class="tw-mb-[15px]">
        <div class="tw-app-input-type-3-label">
          {{ dataLang?.fund_15 }}
        </div>
        <BaseInput
          inputClass="tw-app-input-type-3"
          title="Default Title"
          ref="company_settings__set_req_company_name"
          input-name="company_settings__set_req_company_name"
          :value="getValue(21)?.finreestr_funds__name"
          :disabled="!getValue(21)?.finreestr_funds__is_edit_settings"
          @onInput="updateValue($event, 21)"
        ></BaseInput>
      </div>

      <div class="tw-mb-[15px]">
        <div class="tw-app-input-type-3-label">
          {{ dataLang?.fund_16 }}
        </div>
        <BaseInput
          inputClass="tw-app-input-type-3"
          title="Default Title"
          ref="company_settings__set_req_company_name"
          input-name="company_settings__set_req_company_name"
          :value="getValue(22)?.finreestr_funds__name"
          :disabled="!getValue(22)?.finreestr_funds__is_edit_settings"
          @onInput="updateValue($event, 22)"
        ></BaseInput>
      </div>

      <div class="tw-mb-[15px]">
        <div class="tw-app-input-type-3-label">
          {{ dataLang?.fund_17 }}
        </div>
        <BaseInput
          inputClass="tw-app-input-type-3"
          title="Default Title"
          ref="company_settings__set_req_company_name"
          input-name="company_settings__set_req_company_name"
          :value="getValue(23)?.finreestr_funds__name"
          :disabled="!getValue(23)?.finreestr_funds__is_edit_settings"
          @onInput="updateValue($event, 23)"
        ></BaseInput>
      </div>

      <div class="tw-mb-[15px]">
        <div class="tw-app-input-type-3-label">
          {{ dataLang?.fund_18 }}
        </div>
        <BaseInput
          inputClass="tw-app-input-type-3"
          title="Default Title"
          ref="company_settings__set_req_company_name"
          input-name="company_settings__set_req_company_name"
          :value="getValue(24)?.finreestr_funds__name"
          :disabled="!getValue(24)?.finreestr_funds__is_edit_settings"
          @onInput="updateValue($event, 24)"
        ></BaseInput>
      </div>

      <div class="tw-mb-[15px]">
        <div class="tw-app-input-type-3-label">
          {{ dataLang?.fund_19 }}
        </div>
        <BaseInput
          inputClass="tw-app-input-type-3"
          title="Default Title"
          ref="company_settings__set_req_company_name"
          input-name="company_settings__set_req_company_name"
          :value="getValue(25)?.finreestr_funds__name"
          :disabled="!getValue(25)?.finreestr_funds__is_edit_settings"
          @onInput="updateValue($event, 25)"
        ></BaseInput>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      dataForm: [],
      timeout: null,
    };
  },

  created() {
    this.getFundsSettingsAll();
  },

  methods: {
    ...mapActions("fundsSettingsModule", [
      "getFundsSettingsAll",
      "updateFundsSettingsNames",
    ]),

    updateValue(e, pos) {
      this.dataForm[0] = {
        finreestr_funds__id: this.fundsSettingsData[pos].finreestr_funds__id,
        finreestr_funds__name: e.value,
      };

      clearTimeout(this.timeout);
      this.timeout = setTimeout(this.requestToPath, 600);
    },

    requestToPath() {
      this.updateFundsSettingsNames(this.dataForm);
      clearTimeout(this.timeout);
      this.dataForm = [];
    },

    getValue(pos) {
      if (this.fundsSettingsData[pos]) {
        this.fundsSettingsData[pos].finreestr_funds__name =
          this.dataLang[this.fundsSettingsData[pos].finreestr_funds__name] ??
          this.fundsSettingsData[pos].finreestr_funds__name;
        return this.fundsSettingsData[pos];
      }
      return "";
    },
  },

  computed: {
    ...mapState("fundsSettingsModule", [
      "fundsSettingsData",
      "fundsSettingsLoadStatus",
    ]),
    ...mapState("translationModule", ["dataLang"]),
  },
};
</script>
